import { fromConsignmentResponse, toConsignmentRequest } from '../models/mapper'
import { ConsignmentSave } from '../models/request'
import { Consignment } from '../models/types'
import { createConsignmentV2 } from './http'

// eslint-disable-next-line import/prefer-default-export
export async function createConsignment(data: ConsignmentSave): Promise<Consignment> {
  const response = await createConsignmentV2(toConsignmentRequest(data))
  return fromConsignmentResponse(response)
}
